(function () {
  function getRow(el) {
    return el.closest('.ajax-cart__cart-item, [data-cart-item], .cart__row, tr, li');
  }

  function getQtyInput(row) {
    if (!row) return null;
    return row.querySelector('input[name^="updates"], input[name="quantity"]');
  }

  function getMinFromRow(row) {
    if (!row) return 1;

    var hidden = row.querySelector('.cart-min-qty');
    if (hidden) {
      var n = parseInt(hidden.value || '1', 10);
      if (Number.isFinite(n) && n > 1) return n;
    }

    var input = getQtyInput(row);
    if (input) {
      var d = parseInt(input.getAttribute('data-min-qty') || '1', 10);
      if (Number.isFinite(d) && d > 1) return d;
    }

    return 1;
  }

  function setInputValue(input, qty, minQty) {
    if (!input) return;

    input.value = String(qty);
    input.setAttribute('value', String(qty));
    input.setAttribute('min', String(minQty));
    input.setAttribute('step', String(minQty));
    input.setAttribute('data-min-qty', String(minQty));
  }

  function normalizeQty(value, minQty) {
    var v = parseInt(value || minQty, 10);
    if (!Number.isFinite(v) || v < minQty) return minQty;
    return Math.ceil(v / minQty) * minQty;
  }

  function triggerRowUpdate(row) {
    if (!row) return;

    var btn = row.querySelector('.ajax-cart__item-update--no-js');
    if (btn) {
      btn.click();
      return;
    }

    var form = row.closest('form[action="/cart"], form[action*="/cart"]');
    if (form) {
      try {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } catch (e) {
        form.submit();
      }
    }
  }

  /* WINECOM 20.10.2026: Ereignisse einmal am Dokument statt MutationObserver auf die ganze Seite
     (der Observer lief bei jeder DOM-Aenderung und kostete spuerbar Rechenzeit). */
  var SCOPE = 'form[action="/cart"], form[action*="/cart"], .ajax-cart, #ajax-cart, [data-ajax-cart], .modal-cart, .mini-cart';
  function inScope(el) { return !!(el && el.closest && el.closest(SCOPE)); }

  function bindCartScope(scope) {
    if (!scope || scope.__cartMinQtyBound) return;

    scope.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest
          ? e.target.closest('[data-ajax-qty-increase],[data-ajax-qty-decrease]')
          : null;
        if (!btn || !inScope(btn)) return;

        var row = getRow(btn);
        if (!row) return;

        var minQty = getMinFromRow(row);
        if (minQty <= 1) return; // normale Produkte unverändert

        var input = getQtyInput(row);
        if (!input) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var current = normalizeQty(input.value, minQty);
        var next = current;

        if (btn.hasAttribute('data-ajax-qty-increase')) {
          next = current + minQty;
        } else if (btn.hasAttribute('data-ajax-qty-decrease')) {
          next = Math.max(minQty, current - minQty);
        }

        setInputValue(input, next, minQty);

        setTimeout(function () {
          triggerRowUpdate(row);
        }, 0);
      },
      true
    );

    scope.addEventListener(
      'change',
      function (e) {
        var input = e.target;
        if (!(input instanceof HTMLInputElement) || !inScope(input)) return;

        var name = input.name || '';
        if (!/^updates(\[|$)|^quantity$/.test(name)) return;

        var row = getRow(input);
        if (!row) return;

        var minQty = getMinFromRow(row);
        if (minQty <= 1) return;

        var normalized = normalizeQty(input.value, minQty);
        if (String(normalized) !== String(input.value)) {
          setInputValue(input, normalized, minQty);
          e.preventDefault();
          setTimeout(function () {
            triggerRowUpdate(row);
          }, 0);
        }
      },
      true
    );

    scope.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action="/cart"], form[action*="/cart"]')) return;

        var inputs = form.querySelectorAll('input[name^="updates"], input[name="quantity"]');

        inputs.forEach(function (input) {
          var row = getRow(input);
          if (!row) return;

          var minQty = getMinFromRow(row);
          if (minQty <= 1) return;

          var normalized = normalizeQty(input.value, minQty);
          setInputValue(input, normalized, minQty);
        });
      },
      true
    );

    scope.__cartMinQtyBound = true;
  }

  bindCartScope(document);
})();
